import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../locale/en.json";
import de from "../locale/de.json";
import jp from "../locale/jp.json";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    de: {
      translation: de,
    },
    jp: {
      translation: jp,
    },
  },
  lng: "en",
  interpolation: {
    escapeValue: false,
  },
});
export default i18n;
